<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Stock Order Access</legend>

            <b-alert v-if="rules" show variant="info">
                <div><strong>Provinces with access:</strong> {{ rules.provinces && rules.provinces.length ? rules.provinces.join(', ') : 'None' }}</div>
                <div><strong>Allow-listed user ids:</strong> {{ rules.userIds && rules.userIds.length ? rules.userIds.join(', ') : 'None' }}</div>
                <div><strong>Allow-listed WhatsApp numbers:</strong> {{ rules.whatsAppNumbers && rules.whatsAppNumbers.length ? rules.whatsAppNumbers.join(', ') : 'None' }}</div>
            </b-alert>

            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="Search (name, email, WhatsApp, province):" label-for="input-1">
                        <b-form-input size="sm" v-model="search" input-class="form-control"
                            placeholder="Search"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <br />
                    <b-button type="button" @click="getMerchants" pill variant="outline-dark">
                        Retrieve Report
                    </b-button>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group label-size="sm" label="SMS batch size:" label-for="input-1">
                        <b-form-input size="sm" type="number" min="1" v-model.number="batchSize"
                            input-class="form-control"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="numbers.length">
                <b-col>
                    <div><strong>{{ numbers.length }}</strong> unique WhatsApp numbers, in <strong>{{ batches.length }}</strong> batch(es) of up to {{ batchSize }}:</div>
                    <b-button v-for="(batch, index) in batches" :key="index" type="button" @click="sendBatch(batch)"
                        pill size="sm" variant="outline-success" class="mr-2 mt-2">
                        Send SMS to Batch {{ index + 1 }} ({{ batch.length }} numbers)
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-table striped hover responsive :items="items" :fields="fields" small>
                        <template #cell(fullName)="data">
                            {{ data.item.fullName || '(not registered)' }}
                        </template>
                        <template #cell(createdOn)="data">
                            {{ data.item.createdOn | formateDate }}
                        </template>
                        <template #cell(accessReason)="data">
                            <b-badge variant="success">{{ data.item.accessReason }}</b-badge>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <strong>Total Records: {{ totalRecords }}</strong>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </b-col>
            </b-row>

            <loading :active.sync="isLoading" :is-full-page="true"></loading>
        </div>
    </main>
</div>
